import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import NutUI from "@nutui/nutui";
import { IconFont } from '@nutui/icons-vue'
import "@nutui/nutui/dist/style.css";
import '@nutui/icons-vue/dist/style_iconfont.css'

// qiankun 已禁用，改用 iframe 方案
// import { registerMicroApps, start } from 'qiankun'

const app = createApp(App).use(store).use(router).use(IconFont).use(NutUI)

// qiankun 相关代码已注释，改用 iframe 方案加载子应用
// 子应用通过 iframe 加载，URL: http://${hostname}:3000/static/html/pc.html#/
// 详见 main/src/views/shop.vue

// 以下代码已注释（qiankun 方案）
/*
// 获取微应用入口地址
// 主应用端口：8000（main/vue.config.js）
// 子应用端口：3000（sub/sub-shop/vite.config.js）
// 子应用完整路径：http://192.168.31.14:3000/static/html/pc.html#/
const getMicroAppEntry = () => {
  if (process.env.NODE_ENV === 'production') {
    // 生产环境：使用静态文件路径（构建后的文件）
    return '/sub-shop/'
  } else {
    // 开发环境：使用完整的子应用 URL
    // qiankun 的 entry 应该是子应用的根路径，会自动加载 index.html
    // 获取当前主机的 IP 地址（或使用 localhost）
    const hostname = window.location.hostname
    const protocol = window.location.protocol
    // 子应用运行在 3000 端口，entry 指向根路径
    // qiankun 会自动加载 index.html，子应用内部会根据窗口宽度跳转到 pc.html
    return `${protocol}//${hostname}:3000/`
  }
}

// 注册微应用
// uni-app 使用 hash 路由模式（manifest.json 中配置了 "mode": "hash"）
// qiankun 的 activeRule 匹配的是主应用的路由路径，不是 uni-app 内部的 hash 路由
registerMicroApps([
  {
    name: 'sub-shop', // 微应用名称（对应 manifest.json 中的 name: "sub-shop"）
    entry: getMicroAppEntry(), // 入口地址，指向 uni-app 的 index.html（/sub-shop/index.html）
    container: '#sub-shop-container', // 挂载容器（必须在 DOM 中存在）
    activeRule: '/shop', // 激活路由：当主应用路由为 /shop 时激活微应用
    // uni-app 内部使用 hash 路由（如 #/pages/index/index），这是 uni-app 自己的路由系统
    props: {
      // 传递 token 等数据给微应用
      getToken: () => localStorage.getItem('LOGIN_STATUS_TOKEN'),
      // 传递路由基础路径（uni-app 使用 hash 路由，base 为 "./"）
      routerBase: '/sub-shop/'
    }
  }
], {
  // 生命周期钩子
  beforeLoad: (app) => {
    console.log('[主应用] before load', app.name)
    // 检查登录状态，只有登录了才加载微应用
    const token = localStorage.getItem('LOGIN_STATUS_TOKEN')
    if (!token) {
      console.log('[主应用] 用户未登录，取消加载微应用')
      return Promise.reject(new Error('用户未登录'))
    }
    return Promise.resolve()
  },
  beforeMount: (app) => {
    console.log('[主应用] before mount', app.name)
    return Promise.resolve()
  },
  afterMount: (app) => {
    console.log('[主应用] after mount', app.name)
  },
  beforeUnmount: (app) => {
    console.log('[主应用] before unmount', app.name)
    return Promise.resolve()
  },
  afterUnmount: (app) => {
    console.log('[主应用] after unmount', app.name)
  }
})

// 启动 qiankun
start({
  sandbox: {
    strictStyleIsolation: true, // 严格样式隔离
    experimentalStyleIsolation: true
  },
  prefetch: false, // 关闭预加载
  singular: false // 允许同时运行多个微应用
})
*/

// 监听来自微应用的消息，实现应用间跳转
window.addEventListener('message', (event) => {
  // 验证消息来源（可选，根据实际需求）
  if (event.data && event.data.type === 'navigate') {
    const { path } = event.data
    if (path && router) {
      router.push(path).catch(err => {
        console.warn('[主应用] 路由跳转失败:', err)
      })
    }
  }
})

app.mount('#app')
